import { Button, Modal } from 'react-bootstrap';
import { IDonorRegistration } from '@nkr/models/index';
import {
    formatScheduledDate,
    isPreOpScheduledWithFutureDate,
    isWorkupScheduledWithFutureDate
} from './advanced-reimbursement-workflow';

interface IProps {
    show: boolean,
    registration: IDonorRegistration | null,
    onClose: () => void,
    onConfirm: () => void
}

const AdvancedReimbursementEnrolledScheduleModal = (props: IProps) => {
    const isPreOp = isPreOpScheduledWithFutureDate(props.registration);
    const isWorkup = isWorkupScheduledWithFutureDate(props.registration);
    const milestoneLabel = isPreOp ? 'pre-op' : isWorkup ? 'workup' : 'appointment';
    const appointmentDate = formatScheduledDate(props.registration?.remoteStatusDate);

    return (
        <Modal
            backdrop='static'
            show={props.show}
            onHide={props.onClose}
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
            <Modal.Header closeButton>Advanced Reimbursement</Modal.Header>
            <Modal.Body>
                <p style={{ marginBottom: 12 }}>
                    This donor is enrolled in <strong>Donor Shield Program</strong>.
                </p>
                <p style={{ marginBottom: 0 }}>
                    {appointmentDate
                        ? <>Continue to save the <strong>{milestoneLabel}</strong> appointment date of <strong>{appointmentDate}</strong>.</>
                        : <>Continue to save the <strong>{milestoneLabel}</strong> appointment date.</>}
                </p>
            </Modal.Body>
            <Modal.Footer style={{ borderTop: '0 none' }}>
                <Button onClick={props.onClose}>Cancel</Button>
                <Button bsStyle='primary' onClick={props.onConfirm}>Continue</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default AdvancedReimbursementEnrolledScheduleModal;
